import endpoints from '../_endpoints'
import { usePost } from '../_hooks/usePost'

export const useUserService = () => {
  const [, updateUserData] = usePost()

  const updateUserProfileInformation = async (req) => {
    try {
      const response = await updateUserData({
        url: endpoints.bff.saveUserDetails,
        data: req
      })

      if (!response) {
        console.error(
          `An unexpected error occured while updating user info. Please try again later.`
        )
      }

      return response
    } catch (error) {
      console.error(`An unexpected error occured ${error}.`)
    }
  }

  return { updateUserProfileInformation }
}
